module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.08cb8f79.woff";